angular.module('PatientApp').controller('MessageDetailsCtrl', function($scope, $q, $filter, $state, $log, _, MessagesService, ContextHelperService, ProvidersService, BillsService, LoadingIndicatorService, ErrorsService, PatientUsersService, endpoints){

    var _threadId = $state.params.threadId,
        _loadingKey;

    if(!_threadId){
        $state.go('app.dashboard');
    }

    // Message attachments disabled by default
    $scope.allowMessageAttachments = false;

    $scope.messages = null;
    $scope.errorNotifications = {};

    _loadingKey = LoadingIndicatorService.loading();

    $scope.refreshVirusScanStatus = function(attachmentIds) {
        MessagesService.refreshVirusScanStatus(attachmentIds).then(function(resp) {
            if (resp.changeDetected) {
                $scope.getMessages();
            } else {
                setTimeout(function() {
                    $scope.refreshVirusScanStatus(attachmentIds);
                }, 2500);
            }
        });
    };

    // Load up our messages
    $scope.getMessages = function() {
        MessagesService.getMessages(/*forceLoad*/true).then(function(messages){
            // load the thread into memory so we can populate the peripheral areas of the ui
            $scope.thread = _.first(_.filter(messages, function(thread){
                return _.parseInt(thread.id) === _.parseInt(_threadId);
            }));
            // make sure we always have a valid message thread
            if(!$scope.thread){
                return $q.reject();
            }
            // Load the provider for this thread to determine if we should allow attachments
            ProvidersService.getProviderById($scope.thread.providerId).then(function(provider){
                $scope.allowMessageAttachments = provider.hasFeature('messageAttachments');
            });
            return MessagesService.getDetails(_threadId);
        }).then(function(details) {
            $scope.messages = details;
            var pendingAttachments = [];
            $scope.messages.forEach(function(message) {
                var pendingAttachmentsForMessage = message.attachments.filter(function(attachment) {
                    return 'pending' === attachment.virusScanStatus;
                });
                pendingAttachments = pendingAttachments.concat(pendingAttachmentsForMessage.map(function(attachment) {
                    return attachment.id;
                }));
            });
            if (pendingAttachments.length > 0) {
                $scope.refreshVirusScanStatus(pendingAttachments);
            }            
            return BillsService.getAccountBill($scope.thread.secureCode);
        }, function() {
            $log.error('Unable to load thread details');
            $state.go('app.dashboard');
        }).then(function(bill) {
            $scope.bill = bill;
        }).finally(function(){
            LoadingIndicatorService.complete(_loadingKey);
        });
    };

    $scope.getMessages();

    $scope.messageDetails = {
        message : '',
        attachments: null
    };

    $scope.today = new Date();
    $scope.messageAttachmentFocus = 0;

    // default state of the send ui
    $scope.submitting = false;
    $scope.sendDialog = $filter('translate')('actions.sendMessage');
    $scope.attachFile = $filter('translate')('actions.attachFile');

    $scope.sendMessage = function(){
        $scope.errorNotifications = {};
        if($scope.submitting){
            return;
        }
        if(_.isEmpty($scope.messageDetails.message)){
            if ($scope.messageDetails.attachments && $scope.messageDetails.attachments.length) {
                $scope.errorNotifications.messageRequiredForAttachments = true;
            } else {
                $scope.errorNotifications.messageRequired = true;   
            }
            return;
        }
        $scope.sendDialog = $filter('translate')('actions.sending');
        $scope.submitting = true;
        MessagesService.send($scope.messageDetails, _threadId).then(function(){
            $scope.messageDetails.message = '';
            $scope.messageDetails.attachments = null;
            // TODO: it may make more sense to simply inline add the 
            // content to the dom than to reload the data.
            MessagesService.getDetails(_threadId).then(function(details){
                $scope.messages = details;
            });
        })
        .catch(function(resp){
            switch (ErrorsService.resolve(resp)) {
                case ErrorsService.errors.TOO_MANY_FILES:
                    $scope.errorNotifications.tooManyFiles = true;
                    break;
                case ErrorsService.errors.GENERIC_FILE_ERROR:
                    $scope.errorNotifications.genericFileError = true;
                    break;
                case ErrorsService.errors.FILE_TOO_LARGE:
                    $scope.errorNotifications.fileTooLarge = true;
                    break;
                case ErrorsService.errors.INVALID_FILE_TYPE:
                    $scope.errorNotifications.invalidFileType = true;
                    break;
                default:
                    $scope.errorNotifications.genericFileError = true;
                    break;
            }
        })
        .finally(function(){
            $scope.sendDialog = $filter('translate')('actions.sendMessage');
            $scope.submitting = false;
        });
    };

    $scope.focusAttachement = function(){
        $scope.messageAttachmentFocus++;
    };

    $scope.removeAttachment = function(index){
        $scope.messageDetails.attachments.splice(index, 1);
        $scope.errorNotifications = {}; // clear errors
    };

    $scope.viewBill = function(){
        BillsService.openPdf($scope.bill.secureCode);
    };

    $scope.viewEstimate = function(estimateId) {
        $state.go('app.dashboard.provider.details.estimate-details', {id: $scope.thread.providerId, estimateId: estimateId});
    };

    $scope.buildDownloadUrl = function(attachmentId){
        return endpoints.messages.attachment.url + '/' + attachmentId;
    };

    ProvidersService.getProviders().then(function(providers){
        var hasAccessToMessage = _.some(providers, function(provider){
            return provider.canMessage;
        });
        // show the back to messages breadcrumb if we have access to
        // that section of the application
        if(hasAccessToMessage && $state.previous.name === 'app.messages'){
            ContextHelperService.showBreadCrumbs({
                label: $filter('translate')('actions.backToMessages'),
                onClick: function(){
                    $state.go('app.messages');
                }
            });
        }
    });
});
